import { Injectable } from '@angular/core';
import {
  AccessLicModel,
  DateRanges,
  DirittiFdu,
  IProfiloUtenteModel,
  ModelStrStrWithDefault,
  SESSION,
  fnDateRangeFormat,
} from '@app-lib';
import { HotToastService } from '@ngneat/hot-toast';
import { TranslocoService } from '@ngneat/transloco';
import flatpickr from 'flatpickr';
import { BehaviorSubject, Observable, Subject, combineLatest, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { AlertService } from './alert.service';
import { addDays, subDays } from 'date-fns';

@Injectable({
  providedIn: 'root',
})
export class NavBoxService extends AlertService {
  // globale
  public outletForm$ = new BehaviorSubject<boolean>(false);

  // 0000000000000
  headerFilter: string;

  private _filter_listener = new Subject<any>();
  // imposta hidden per il camopo cerca
  private _search_box_is_visible = new BehaviorSubject<boolean>(false);
  // imposta hidden per l'icona xls
  private _xls_icon_visible = new Subject<boolean>();
  // gestisce il click sull'icona
  private _listner_click_xls = new Subject<any>();
  // imposta hidden per l'icona xls
  private _pdf_icon_visible = new Subject<boolean>();
  // gestisce il click sull'icona
  private _listner_click_pdf = new Subject<any>();
  // la select  in navigatio
  private _navselect_visible = new BehaviorSubject<any>(false);
  public navSelectVisible$: Observable<any> = this._navselect_visible.asObservable();
  private _navselected_value = new BehaviorSubject<any>(null);
  private _store_navselect_set_model = new BehaviorSubject<any>(null);
  public navSelectModel$: Observable<any> = this._store_navselect_set_model.asObservable();

  // nasconde tutta la navbar
  private _navbar = new Subject<boolean>();
  // imposta hidden per le date
  // private _date_picker_visible = new Subject<boolean>();

  //   // memorizza le date calendario
  private _store_date_range_picker = new BehaviorSubject<DateRanges>(null);
  private _date_range_picker_visible = new BehaviorSubject<boolean>(false);

  private _store_switch_value = new BehaviorSubject<boolean>(null);
  public navSwitchValue$: Observable<any> = this._store_switch_value.asObservable();
  private _store_switch_visible = new BehaviorSubject<boolean>(true);
  // search set exist value
  public subjSearchSetValue$ = new BehaviorSubject<string>(null);
  // navbar
  public _store_sidebar_collapsed = new BehaviorSubject<boolean>(null);
  public navSideBarCollapsed$: Observable<boolean> = this._store_sidebar_collapsed.asObservable();
  // licenza
  public subjLicenza$ = new BehaviorSubject<AccessLicModel>(null);
  public obsLicenza$: Observable<AccessLicModel> = this.subjLicenza$.asObservable();
  // profilo
  public subjProfilo$ = new BehaviorSubject<IProfiloUtenteModel>(null);
  public obsProfilo$: Observable<IProfiloUtenteModel> = this.subjProfilo$.asObservable();

  // mobile
  public is_mobile$ = new BehaviorSubject<boolean>(false);
  public diritti$: Observable<DirittiFdu>;

  // downloading xls
  public downloading = new BehaviorSubject<boolean>(false);
  public downloading$: Observable<boolean> = this.downloading.asObservable();
  // refresh_nav_divisioni
  public refresh_nav_divisioni$ = new BehaviorSubject<boolean>(false);

  // https://stackoverflow.com/questions/45303683/angular-4-execute-function-from-another-component/45305052
  // https://stackoverflow.com/questions/48165518/transfer-the-value-of-input-search-bar-between-non-child-components-angular-2
  constructor(private _hts: HotToastService) {
    super(_hts);
    // mette in default invisibile l'icona xls
    this._xls_icon_visible.next(false);
    this._navbar.next(true);
    //  this.params();
    // this.params(new NavbarCommands());
  }
  // utility resize

  public setResolution(px: number) {
    if (px < 769) {
      this.is_mobile$.next(true);
    } else {
      this.is_mobile$.next(false);
    }
  }

  // ===================== date pickers ======================

  // ======== inizializza lato client ========
  /*
  setDateFrom(date: any) {
    this._store_date_from.next(date);
  }
  setDateTo(date: any) {
    this._store_date_to.next(date);
  }*/

  // ======== inizializza date range ======== //
  setDateRangePickerValue(date: DateRanges) {
    this._store_date_range_picker.next(date);
  }

  // lato client subscribe calendar
  getDateRangePickerValue$(): Observable<DateRanges> {
    return this._store_date_range_picker.asObservable();
  }

  // get hidden lato navbar
  getDateRangePickerVisibility$(): Observable<boolean> {
    return this._date_range_picker_visible.asObservable();
  }
  // setta hidden lato richiesta
  setDateRangePickerVisibility(val: boolean = false) {
    this._date_range_picker_visible.next(val);
  }

  // ===========date picker ===============
  // date pickers lato nav
  /*
  navDatePickerFromSubject(date: any) {
    this._datepicker_from_listener.next(date);
  }
  // lato client subscribe
  datepicker_from_listener(): Observable<any> {
    return this._datepicker_from_listener.asObservable();
  }
  // date picker lato nav
  navDatePickerToSubject(date: any) {
    this._datepicker_to_listener.next(date);
  }
  // lato client subscribe
  datepicker_to_listener(): Observable<any> {
    return this._datepicker_to_listener.asObservable();
  }
*/
  // ============== switch inizio  ====================
  // lato nav  per lo switch
  navSwitchValue(b: boolean) {
    this._store_switch_value.next(b);
  }

  // lato client subscribe
  switch_value_listener(): Observable<boolean> {
    return this._store_switch_value.asObservable();
  }

  navSwitchVisible() {
    return this._store_switch_visible.asObservable();
  }

  /*
  switch_visible_listener(): Observable<any> {
    return this._store_switch_visible.asObservable();
  }*/
  // ==================== cerca =====================
  // ----->>>  vecchi  lato nav subscribe
  navFilterEvent(filterBy: string) {
    this._filter_listener.next(filterBy);
  }
  /*
  navFilterPlaceholderListener(): Observable<any> {
    return this._filter_listner_placeholder.asObservable();
  }

  filter_placeholder_set(ph: string) {
    if (ph.length > 2) {
      this._filter_listner_placeholder.next(ph);
      // attenzione peer la translazione prima era
      // this._filter_listner_placeholder.next(this._t.get(ph));
    } else {
      this._filter_listner_placeholder.next(null);
    }
  }*/

  // .... visibilità ....
  //  ========== tutti in uno lato client  ==========
  visiblity(
    search: boolean = false,
    datepicker: boolean = false,
    xls: boolean = false,
    pdf: boolean = false,
    nav_select: boolean = false
  ) {
    this._search_box_is_visible.next(search);
    this._date_range_picker_visible.next(datepicker);
    this._xls_icon_visible.next(xls);
    this._pdf_icon_visible.next(pdf);
    this._navselect_visible.next(nav_select);
  }
  // ================ search ====================
  // .... su cambio testo  ....
  // lato navbar
  navSearchOnChangeEvent(filterBy: string) {
    this._filter_listener.next(filterBy);
  }
  // lato client subscribe
  search_listener(): Observable<any> {
    return this._filter_listener.asObservable();
  }
  // .... visibilità ....
  // lato client
  search_is_visible(val: boolean = true) {
    this._search_box_is_visible.next(val);
  }
  // lato nav
  navSearchIsVisible(): Observable<boolean> {
    return this._search_box_is_visible.asObservable();
  }
  // set value to search

  // lato client subscribe
  search_set_value(val: string = null) {
    this.subjSearchSetValue$.next(val);
  }
  // lato nav subscribe
  navSearchSetValue(): Observable<string> {
    return this.subjSearchSetValue$.asObservable();
  }
  // ============== XLS icon ====================
  // .... on click ....
  // listener lato navbar
  listener_ToXls(): Observable<any> {
    return this._listner_click_xls.asObservable();
  }
  // scatena l'evento lato richiedente
  navXlsOnclick() {
    this._listner_click_xls.next(true);
  }
  // .... visibilità ....
  // setta hidden lato richiesta
  xls_show_ico(val: boolean = false) {
    this._xls_icon_visible.next(val);
  }
  // osservabile lato navbar
  navXlsShowIco(): Observable<boolean> {
    return this._xls_icon_visible.asObservable();
  }
  // ================ PDF icon ====================
  // scatena l'evento lato richiedente
  navPdfOnclick() {
    this._listner_click_pdf.next(true);
  }
  listener_ToPdf(): Observable<any> {
    return this._listner_click_pdf.asObservable();
  }
  // .... visibility .......
  pdf_show_ico(val: boolean = false) {
    this._pdf_icon_visible.next(val);
  }
  // get hidden lato navbar
  navPdfShowIco(): Observable<boolean> {
    return this._pdf_icon_visible.asObservable();
  }

  // ---------- nav select ----------//

  // ======== inizializza lato client ========
  setNavSelectOptions(data: any) {
    if (data) {
      this._store_navselect_set_model.next(data);
      this._navselect_visible.next(true);
    } else {
      this._navselect_visible.next(false);
    }
  }
  /*  non usata:  quando setNavSelectOptions passa i dati diventa visibile
  // setta hidden lato richiesta
  public navselect_visible(val: boolean = false) {
    this._navselect_visible.next(val);
  }*/
  // parte navbar

  public navSelectedValue(val: string) {
    this._navselected_value.next(val);
  }
  public listener_NavSelectedValue(): Observable<string> {
    return this._navselected_value.asObservable();
  }

  // ----------- fine seect navbar ---------------- //

  // ===================== sidebar =========================

  //  tramite parte nav e parte client (subscribe a listener per i cambiamenti)
  // lato nav  per lo switch
  /*
  navSidebarCollapsed(b: boolean = null): boolean {
    let ses: boolean;
    if (b == null) {
      ses = this.Session_SidebarCollapsed();
    } else {
      if (b == true) {
        ses = this.Session_SidebarCollapsed(true);
      } else {
        ses = this.Session_SidebarCollapsed(false, true);
      }
    }
    this._store_sidebar_collapsed.next(ses);
    return ses;
  }*/
  navSidebarCollapsed(b: boolean = null) {
    this._store_sidebar_collapsed.next(b);
  }
  navSidebarCollapsed_IsNull(): boolean {
    return this._store_sidebar_collapsed.value == null;
  }
  // lato client subscribe
  listener_SidebarCollapsed(): Observable<boolean> {
    return this._store_sidebar_collapsed.asObservable();
  }
  // gestisce la session
  private Session_SidebarCollapsed(set_true: boolean = false, set_false: boolean = false): boolean {
    // set se c'è un parametro
    // se non è collapsed rimuove la session
    if (set_false === true) {
      sessionStorage.removeItem(SESSION.SIDEBAR_COLLAPSED);
      return false;
    } else if (set_true === true) {
      // se  è collapsed mette una session
      sessionStorage.setItem(SESSION.SIDEBAR_COLLAPSED, '#');
      return true;
    } else {
      // get
      const r = sessionStorage.getItem(SESSION.SIDEBAR_COLLAPSED);
      return r == null ? false : true;
    }
  }
  //-----------------------------------------------------//
  //------------------ utilità --------------------------//
  //-----------------------------------------------------//
  /*
  DatePickerLocalize(locale: string = 'it') {
    if (locale == 'en') {
      locale = 'uk';
    }
    const l = require(`flatpickr/dist/l10n/${locale}.js`);
    flatpickr.localize(l.default[locale]);
    return flatpickr;
  }
 */
  // lato client subscribe

  refreshNavBarListDivisioni() {
    let val = this.refresh_nav_divisioni$.value;
    this.refresh_nav_divisioni$.next(!val);
  }
  // ---------- SESSION ------------//
  // memorizza il testo cercato e lo ripropone
  public SessionSearchBox(cname: string, set_searched_text: string = null, remove: boolean = false): string | null {
    const skey = SESSION.PREFIX_SEARCH_BOX + cname;
    if (remove) {
      sessionStorage.removeItem(skey);
      return null;
    }
    if (set_searched_text) {
      set_searched_text = set_searched_text.toLowerCase();
    }
    if (set_searched_text) {
      sessionStorage.setItem(skey, set_searched_text);
      //onsole.log('--data set ->' + JSON.stringify(data, null, 4));
      return null;
    }
    const ft = sessionStorage.getItem(skey);
    if (ft) {
      return ft;
    } else {
      return null;
    }
  }

  // ----- SESSION NAV SELECT --- //
  // ---------------- select in navbar -------------- //
  /// setta i dati e la visibilità della select in navbar
  // 1 chiamata e settata in client front
  // 2 avvia la visibilità su navbar
  // 3 in caso di remove annulla
  public SessionNavSelect(
    cname: string,
    model: ModelStrStrWithDefault = null,
    remove: boolean = false
  ): ModelStrStrWithDefault | null {
    const key = SESSION.PREFIX_NAV_SELECT + cname;
    if (remove) {
      sessionStorage.removeItem(key);
      return null;
    }

    if (model) {
      const _data = JSON.stringify(model);
      sessionStorage.setItem(key, _data);
      return model;
    }
    const ft = sessionStorage.getItem(key);

    if (ft) {
      return JSON.parse(ft);
    } else if (model) {
      const _data = JSON.stringify(model);
      sessionStorage.setItem(key, _data);

      return model;
    } else {
      return null;
    }
  }

  public GetNavSelectModel(cname: string, t: TranslocoService): Observable<ModelStrStrWithDefault> {
    if (cname == 'magazzinirda') {
      //onsole.log('- cname == magazzinirda? -->' + JSON.stringify(cname, null, 4));
      const $0 = t.selectTranslate('campo.DtRichiesta');
      const $1 = t.selectTranslate('campo.DtPrevConsegna');
      const $2 = t.selectTranslate('campo.DtCaricato');
      return combineLatest([$0, $1, $2]).pipe(
        map((t) => {
          return <ModelStrStrWithDefault>{
            DefaultStr: 'DtRichiesta',
            ListModelStrStr: [
              {
                Text: t[0],
                Value: 'DtRichiesta',
              },
              {
                Text: t[1],
                Value: 'DtPrevConsegna',
              },
              {
                Text: t[2],
                Value: 'DtCaricato',
              },
            ],
          };
        })
      );
    } else {
      return of(<ModelStrStrWithDefault>{
        DefaultStr: 'err',
        ListModelStrStr: [
          {
            Text: 'NG.NAV.SEL.ER.00 Modello non valido cname: ' + cname,
            Value: 'err',
          },
        ],
      });
    }
  }

  // ---------- SESSION ------------//
  // ============ date range picker ============== //

  public setSessionDateRanges(key: string, dateRange: DateRanges, remove: boolean = false) {
    key = SESSION.PREFIX_DATES_RANGE + key;
    if (remove) {
      sessionStorage.removeItem(key);
      return;
    }
    if (dateRange) {
      const obj = JSON.stringify(dateRange);
      sessionStorage.setItem(key, obj);
    } else {
      alert('dates error in security service');
    }
  }
  public getSessionDateRange(key): DateRanges | null {
    key = SESSION.PREFIX_DATES_RANGE + key;
    const ft = sessionStorage.getItem(key);
    if (ft) {
      return JSON.parse(ft) || null;
    } else {
      return null;
    }
  }

  initDateRange(cname: string, setting_days: number, force: boolean = false): DateRanges {
    let ret: DateRanges;
    const _session = this.getSessionDateRange(cname);
    if (_session && force == false) {
      ret = _session;
    } else {
      let _d: number;
      _d = Number(setting_days);
      const now = new Date();
      let day_from: Date;
      let day_to: Date;
      switch (true) {
        case _d < 0: {
          // va nel futuro di x giorni
          day_from = now;
          day_to = addDays(now, _d);
          break;
        }
        case _d > 0: {
          // nel passato
          day_from = subDays(now, _d);
          day_to = now;
          break;
        }
        default: {
          day_from = subDays(now, 1);
          day_to = now;
        }
      }

      ret = fnDateRangeFormat({ from: day_from, to: day_to });
      this.setSessionDateRanges(cname, ret);
    }
    return ret;
  }
  // f
}

/*
  // ========== TOASTER =========== //
  ShowApiError(x: ApiError) {
    let tmessage = `
            <b>${x.Message}</b><br />
            <small> `;
    if (x.Code) {
      tmessage += `code:  ${x.Code}<br />`;
    }
    if (x.Reference) {
      tmessage += `ref:  ${x.Reference}<br />`;
    }
    if (x.ServerResponse) {
      tmessage += `ref:  ${x.ServerResponse}<br />`;
    }
    tmessage += `</small>`;

    if (x.Continue && x.Continue == true) {
      return this._toast.warning(tmessage, {
        dismissible: true,
        duration: 5000,
      });
    } else {
      return this._toast.error(tmessage, {
        autoClose: false,
        dismissible: true,
      });
    }
  }
  // -- //

  ShowIsError(x: IsError | IsErrorValues) {
    let tmessage = `
            <b>${x.Message}</b><br />
            <small>
            code:  ${x.Code}<br /></small>`;

    if (x.Continue && x.Continue == true) {
      return this._toast.warning(tmessage, {
        dismissible: true,
        duration: 5000,
      });
    } else {
      return this._toast.error(tmessage, {
        duration: 5000,
        dismissible: true,
      });
    }
  }

  ToastError(message: string) {
    return this._toast.error(message, {
      autoClose: false,
      dismissible: true,
    });
  }
  ToastInfo(message: string) {
    return this._toast.info(message, {
      dismissible: true,
      duration: 8000,
    });
  }
  ToastSuccess(message: string) {
    return this._toast.success(message, {
      dismissible: true,
      duration: 5000,
    });
  }
  ToastWarning(message: string) {
    return this._toast.warning(message, {
      dismissible: true,
      duration: 8000,
    });
  }
  ToastShow(title: string, message: string) {
    const msg = `<h5 class="text-secondary">${title}</h5>
                  <p>${message}</p>`;

    return this._toast.info(msg, {
      dismissible: true,
      duration: 25000,
    });
  }
}
*/
